import * as React from 'react'

import { Banner } from '../../components/molecules/Banner'
import { CardGrid } from '../../components/molecules/CardGrid'

export const LandingPage: React.FC = () => {
    return (
        <div>
            <Banner />
            <CardGrid/>
        </div>
    )
}
